import api from '../api/axios';

// Get all systems for a proposal
const getSystems = (proposalId) => {
  return api.get(`proposal/${proposalId}/systems`);
};

// Get a specific system
const getSystem = (proposalId, systemId) => {
  return api.get(`proposal/${proposalId}/systems/${systemId}`);
};

// Create a new system
const createSystem = (proposalId, data) => {
  return api.post(`proposal/${proposalId}/systems`, data);
};

// Update a system
const updateSystem = (proposalId, systemId, data) => {
  return api.patch(`proposal/${proposalId}/systems/${systemId}`, data);
};

// Delete a system
const deleteSystem = (proposalId, systemId) => {
  return api.delete(`proposal/${proposalId}/systems/${systemId}`);
};

// Add equipment to a system
const addEquipment = (proposalId, systemId, data) => {
  return api.post(`proposal/${proposalId}/systems/${systemId}/equipments`, data);
};

// Update equipment
const updateEquipment = (proposalId, systemId, equipmentId, data) => {
  return api.patch(`proposal/${proposalId}/systems/${systemId}/equipments/${equipmentId}`, data);
};

// Remove equipment
const removeEquipment = (proposalId, systemId, equipmentId) => {
  return api.delete(`proposal/${proposalId}/systems/${systemId}/equipments/${equipmentId}`);
};

// Reorder equipments
const reorderEquipments = (proposalId, systemId, equipmentIds) => {
  return api.post(`proposal/${proposalId}/systems/${systemId}/equipments/reorder`, { equipmentIds });
};

const proposalSystemsServices = {
  getSystems,
  getSystem,
  createSystem,
  updateSystem,
  deleteSystem,
  addEquipment,
  updateEquipment,
  removeEquipment,
  reorderEquipments,
};

export default proposalSystemsServices;

